import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _initializerDefineProperty from "@babel/runtime/helpers/esm/initializerDefineProperty";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/esm/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/esm/initializerWarningHelper";
var _excluded = ["docId"],
  _excluded2 = ["docId"];
var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec0, _dec1, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor0, _descriptor1, _descriptor10, _descriptor11, _descriptor12;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.number.parse-int.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/esnext.set.add-all.js";
import "core-js/modules/esnext.set.delete-all.js";
import "core-js/modules/esnext.set.difference.js";
import "core-js/modules/esnext.set.every.js";
import "core-js/modules/esnext.set.filter.js";
import "core-js/modules/esnext.set.find.js";
import "core-js/modules/esnext.set.intersection.js";
import "core-js/modules/esnext.set.is-disjoint-from.js";
import "core-js/modules/esnext.set.is-subset-of.js";
import "core-js/modules/esnext.set.is-superset-of.js";
import "core-js/modules/esnext.set.join.js";
import "core-js/modules/esnext.set.map.js";
import "core-js/modules/esnext.set.reduce.js";
import "core-js/modules/esnext.set.some.js";
import "core-js/modules/esnext.set.symmetric-difference.js";
import "core-js/modules/esnext.set.union.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.timers.js";
import { Component, Vue, Prop, Watch, State } from 'nuxt-property-decorator';
import AvailabilityPopup from '@/components/popup/availability-popup.vue';
import DocumentListItem from '@/components/document-list-item.vue';
import BodyContent from '@/components/viewer/body-content.vue';
import BodyContentLoading from '@/components/viewer/body-content-loading.vue';
import ConfirmDialog from '@/components/common/confirm-dialog.vue';
import DocumentConfigDialog from '@/components/document-config-dialog.vue';
import AddSectionBookmarkDialog from '@/components/dialog/add-section-bookmark.vue';
import AddQuickAccessWebItemDialog from '@/components/quickAccess/add-web-item.vue';
import DocumentFindbar from '@/components/viewer/document-findbar.vue';
import SelectionToolbox from '@/components/viewer/selection-toolbox.vue';
import KommentarArticleBar from '@/components/viewer/kommentar-article-bar.vue';
import { getKeyFromSeq, mergeSortedArraysToUniqueArray } from '@/utility';
import { convertSectionResponseToContents, depthByKey, convertSectionsIntoIndex, getAncesterSection, generateWebviewerSections, isSectionContent, mapByKey, mapBySeries, extractHighlightContentsWithColor, getTocByKey } from '@/utils/webViewerUtils';
import { uniqArray, getMappedObject } from '@/utils/arrayUtil';
import { descriptionValidator, highlightColorName } from '@/utils/binderFoldersUtils';
import { compareNode, getHighlightFromSingleNode, getHighlightsFromMultiNode, getMiddleNodesFromSelectionByKey, getWrapperNode } from '@/utils/selectionUtils';
import * as Constants from '@/constants';
import { fragmentBibliography, fragmentUrl } from '@/utils/copyFragmentUtils';
import { BookmarkViewTypeEnumWeb, QuickAccessItemTypeWebPropertiesViewTypeEnum } from 'wklr-backend-sdk/models';
import { isAccessible } from '@/utils/documentUtils';
import { useContentMouseEvent } from '@/modules/useContentMouseEvent/useContentMouseEvent';
import ContextMenu from '@/components/shared/context-menu';
import { endNavigationOrPageloadSpan } from '@/utils/sentryUtils';

// TODO: Finder 文脈の HighlightedContent と型定義からいい感じに生成したい
var WebViewer = (_dec = Component({
  components: {
    AvailabilityPopup: AvailabilityPopup,
    ConfirmDialog: ConfirmDialog,
    ContextMenu: ContextMenu,
    DocumentConfigDialog: DocumentConfigDialog,
    AddSectionBookmarkDialog: AddSectionBookmarkDialog,
    AddQuickAccessWebItemDialog: AddQuickAccessWebItemDialog,
    DocumentFindbar: DocumentFindbar,
    DocumentListItem: DocumentListItem,
    BodyContent: BodyContent,
    BodyContentLoading: BodyContentLoading,
    KommentarArticleBar: KommentarArticleBar,
    SelectionToolbox: SelectionToolbox
  }
}), _dec2 = Prop(), _dec3 = Prop(), _dec4 = Prop(), _dec5 = Prop(), _dec6 = Prop(), _dec7 = Prop(), _dec8 = Prop(), _dec9 = State(function (state) {
  return state.document.find;
}), _dec0 = State(function (state) {
  return state.search.query;
}), _dec1 = State(function (state) {
  return state.persistent.documentConfig;
}), _dec10 = Prop(), _dec11 = Prop(), _dec12 = Watch('inViewSectionsWithAncestors'), _dec13 = Watch('find.hit.current'), _dec14 = Watch('isPreview'), _dec15 = Watch('record'), _dec16 = Watch('highlightDialog'), _dec17 = Watch('indexListForContents'), _dec(_class = (_class2 = /*#__PURE__*/function (_Vue) {
  function WebViewer() {
    var _this;
    _classCallCheck(this, WebViewer);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, WebViewer, [].concat(args));
    _this.isSectionContent = isSectionContent;
    _this.descriptionValidator = descriptionValidator;
    _this.getTocByKey = getTocByKey;
    _this.isAccessible = isAccessible;
    //
    // PROPS & STORE
    //
    /** 表示中の文書データ */
    _initializerDefineProperty(_this, "record", _descriptor, _this);
    /** ロード時に表示するページ (1-index) */
    _initializerDefineProperty(_this, "initialPage", _descriptor2, _this);
    /** ロード時に表示するセクション */
    _initializerDefineProperty(_this, "initialKey", _descriptor3, _this);
    /** ロード時に表示するコンテント */
    _initializerDefineProperty(_this, "initialSeries", _descriptor4, _this);
    // ロード時に表示するコンテンツを強調表示するか
    _initializerDefineProperty(_this, "emphasized", _descriptor5, _this);
    /** プレビューモード (ツールバー非表示、文書内リンクのクリック無効化など) かどうか */
    _initializerDefineProperty(_this, "isPreview", _descriptor6, _this);
    /** FIXME: バグ対応のために追加 */
    _initializerDefineProperty(_this, "isDocumentPage", _descriptor7, _this);
    /** ハイライトすべきキーワード */
    _initializerDefineProperty(_this, "find", _descriptor8, _this);
    /** URLパラメータからロードされるクエリ */
    _initializerDefineProperty(_this, "storedQuery", _descriptor9, _this);
    /** 閲覧画面の設定 */
    _initializerDefineProperty(_this, "config", _descriptor0, _this);
    //
    // STATE
    //
    _this.query = {
      keyword: ''
    };
    /** 文章データ。 ToC を元にに構造化されており、ローディングが完了したらコンテンツの実体もこの中にもつ */
    _this.WebviewerSections = [];
    /** in-viewなcontentのseries */
    _this.seriesOfInViewContents = [];
    /** ページ境界線の表示 */
    _this.pageBorderMarker = {
      above: null,
      below: null
    };
    /** 注ポップアップ */
    _this.sidenotePopup = null;
    /** Legalscapeに収録されていますポップアップ */
    _this.availabilityPopupTargetDocumentId = null;
    /** 文書内検索をだすかどうか */
    _this.isShowSearchBox = false;
    /** フラッシュ表示するシリーズ */
    _this.flashSeries = null;
    /** フラッシュ表示するセクション */
    _this.flashSection = null;
    /** 自分のもっているバインダーの一覧 */
    _this.binders = [];
    /** 外部から差し込まれるブックマーク */
    // TODO: LS-77 対応時に整理する
    _initializerDefineProperty(_this, "bookmark", _descriptor1, _this);
    /** 書籍に含まれるブックマークの一覧。ブックマーク情報にバインダー情報を追加したもの */
    // TODO: LS-77 対応時に整理する
    _this.bookmarksWithBinderDetail = {};
    _this.quickAccessItems = {};
    /** 外部から差し込まれるハイライト */
    // TODO: LS-77 対応時に整理する
    _initializerDefineProperty(_this, "highlight", _descriptor10, _this);
    /** 書籍に含まれるハイライトの一覧 */
    // 表示用にメタ情報が消えてしまっている。現時点では問題ないが、必要に応じてデータ構造を変える必要がある
    // TODO: LS-77 対応時に整理する
    _this.innerHighlights = {};
    /** 初回ロードが完了したかどうか。初回ロード前に IntersectionObserver が登録されると途中の要素がロードされて表示位置にずれが発生するので制御のために使用する */
    _this.isFirstLoadDone = false;
    /**
     * テキスト選択範囲の位置情報
     * 文字数制限されたため右上の位置が検出できなくなったため配置が左上になっている
     * FIXME: 選択範囲の計算はもっとちゃんと作れるみたいなので品質を上げたいなら作り込む
     */
    _this.selectionPosition = {
      top: 0,
      right: 0,
      left: 0,
      wrapperRight: 0
    };
    _this.kommentarArticles = [];
    _this.isKommentarArticleBarOpen = false;
    /** 特殊参照リンクホバー時に表示するコンテキストメニュー用のオブジェクト */
    _this.contextMenuModal = {
      visible: false,
      query: undefined,
      positionY: 0,
      positionX: 0,
      items: [],
      isLoading: false,
      openTimer: undefined,
      closeTimer: undefined,
      OPEN_INTERVAL: 300,
      CLOSE_INTERVAL: 100
    };
    /** 外部リンクホバー時に表示するツールチップ用のオブジェクト */
    _this.tooltip = {
      visible: false,
      positionY: 0,
      positionX: 0,
      text: ''
    };
    /** 本文中の何かのクリック */
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    _this.clickContent = function () {};
    /** 本文中の何かのmouseover */
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    _this.mouseoverContent = function () {};
    /** 本文中の何かのmouseout */
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    _this.mouseoutContent = function () {};
    _initializerDefineProperty(_this, "isPreviewWatcher", _descriptor11, _this);
    _initializerDefineProperty(_this, "recordWatcher", _descriptor12, _this);
    // ハイライト登録用データモデル
    _this.selection = null;
    _this.highlightDialog = false;
    _this.selectedBinderToHighlight = null;
    _this.editingHighlightDescription = '';
    return _this;
  }
  _inherits(WebViewer, _Vue);
  return _createClass(WebViewer, [{
    key: "disableBookmark",
    get: /** ブックマークとハイライトを無効にする */
    function get() {
      return this.$domain.isMHMMypage;
    }
  }, {
    key: "indexListForContents",
    get:
    //
    // COMPUTED
    //

    /** 文書を構成する series の配列 */
    function get() {
      return convertSectionsIntoIndex(this.WebviewerSections);
    }
  }, {
    key: "handleDocumentErrorToast",
    value: function handleDocumentErrorToast() {
      var _this2 = this;
      if (!this.showDocumentErrorToast) {
        this.$toast.error('文書取得エラー');
        this.showDocumentErrorToast = true;
        setTimeout(function () {
          _this2.showDocumentErrorToast = false;
        }, 6000);
      }
    }
  }, {
    key: "sectionGetter",
    value: function sectionGetter(index) {
      if (index.type === 'section') {
        return this.WebviewerSections[index.key];
      } else {
        var contents = this.WebviewerSections[index.key].contents;
        var content = contents.find(function (content) {
          return content.series === index.series;
        });
        return content;
      }
    }
  }, {
    key: "getKeyFromSeries",
    value: function getKeyFromSeries(series) {
      var index = this.indexListForContents.find(function (index) {
        if (index.type === 'content') {
          return index.series === series;
        }
      });
      if (index === undefined) return undefined;
      var content = this.sectionGetter(index);
      if (content && isSectionContent(content)) {
        return content.parent;
      }
      return undefined;
    }

    /** in-viewなセクションのkey */
    // FIXXME: `keysOfInViewSections` が正しい。 $emit 経由で他のコンポーネントでも同様に使われているので修正する
  }, {
    key: "inViewSections",
    get: function get() {
      var _this3 = this;
      var inViewSection = this.seriesOfInViewContents.map(function (series) {
        return _this3.getKeyFromSeries(series);
      }).filter(function (series) {
        return series !== undefined;
      });
      return uniqArray(inViewSection).sort();
    }

    /** in-viewなセクションとその祖先セクションのkey */
    // FIXXME: `keysOfイnViewSectionsWithAncestors` が正しい。 $emit 経由で他のコンポーネントでも同様に使われているので修正する
  }, {
    key: "inViewSectionsWithAncestors",
    get: function get() {
      var _this4 = this;
      var inviewSectionAncestors = this.inViewSections.flatMap(function (toc) {
        var ancester = getAncesterSection(toc, _this4.WebviewerSections);
        console.log('inViewSectionsWithAncestors: ', ancester, toc);
        return [toc].concat(_toConsumableArray(ancester));
      });
      return uniqArray(inviewSectionAncestors).sort();
    }

    /**
     * 「現在見ている」contentのseriesを求める
     *
     * 1. contentのin-viewを、以下のどちらかを満たすこととする
     *    a) そのcontentの全体が表示領域内にある
     *    b) そのcontentの表示領域内に表示されている部分が表示領域の高さの5%以上を占めている
     * 2. 現在見ているcontentとは、in-viewなcontentのうち最も上にある（先頭に近い）もの
     *
     * TODO: 仕様の更新と必要に応じて実装を修正する
     * 上記の仕様は isPartiallyInView で実装されていたが、 intersectionObserver を利用する際に利用を停止した
     * plugin 側の intersection observer を利用するようにするタイミングで修正できそう
     */
  }, {
    key: "currentSeries",
    get: function get() {
      if (this.seriesOfInViewContents.length > 0) {
        return this.seriesOfInViewContents[0];
      }
    }

    /**
     * 「現在見ている」書籍上のページ (0-index) を求める
     */
  }, {
    key: "currentPageSeq",
    get: function get() {
      var _this5 = this;
      if (this.seriesOfInViewContents.length > 0) {
        var index = this.indexListForContents.find(function (index) {
          if (index.type === 'content') {
            return index.series === _this5.seriesOfInViewContents[0];
          }
        });
        if (index === undefined) return undefined;
        var content = this.sectionGetter(index);
        if (content && isSectionContent(content)) {
          return content.topPageSeq;
        }
      }
    }

    /**
     * 現在見ているパラグラフのURLを返す
     */
  }, {
    key: "inViewContentUrl",
    get: function get() {
      var _iterator = _createForOfIteratorHelper(this.seriesOfInViewContents),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var series = _step.value;
          var key = this.getKeyFromSeries(series);
          if (key) {
            return "/document/".concat(this.record.id, "#key=").concat(key, "&series=").concat(series);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return "/document/".concat(this.record.id);
    }

    /**
     * initialPage が指定されている時に対応するセクションを返す
     */
  }, {
    key: "initialKeyByPage",
    get: function get() {
      if (this.initialPage === null) return null;
      return getKeyFromSeq(this.record.toc, this.initialPage - 1) || null;
    }

    /** 検索結果のトータル数 */
  }, {
    key: "findHitTotal",
    get: function get() {
      if (this.find.hit.documentHits === null) return 0;
      return this.find.hit.documentHits.total;
    }

    /** 検索実行中（APIコール中）であればtrue */
  }, {
    key: "searching",
    get: function get() {
      return this.find.keywords.length > 0 && this.find.hit.documentHits === null;
    }

    /** this.load() の waitForLoad がタイムアウトしたときのトースト */
  }, {
    key: "loadFailureToastOptions",
    get: function get() {
      return {
        message: 'コンテンツの読み込みに失敗しました。<br>もう一度同じ操作をしても問題が解決しない場合は、<br>お手数ですがサポートまでご連絡をお願いいたします。',
        type: 'error',
        duration: 0,
        dismissible: true
      };
    }
  }, {
    key: "kommentarArticlesMap",
    get: function get() {
      return getMappedObject(this.kommentarArticles);
    }
    /**
     * 配列から表示箇所に対応した key を持つ最初の KommentarArticle を返す
     */
  }, {
    key: "kommentarArticle",
    get: function get() {
      var _this6 = this;
      if (!this.record.isKommentar) return null;
      var hasKommentarArticleKey = this.inViewSectionsWithAncestors.find(function (key) {
        return _this6.kommentarArticlesMap.get(key);
      });
      if (hasKommentarArticleKey === undefined) return null;
      var article = this.kommentarArticlesMap.get(hasKommentarArticleKey);
      return article || null;
    }

    // 本質的にここの `_` prefix は必要ない. しかしこれをつけないと typescript-eslint が no-unused-vars のエラーを出してしまう.
    // typescript-eslint のバージョンを v6 系以上にまで上げて仕舞えば治るはず
  }, {
    key: "uiStyle",
    get: function get() {
      var _this7 = this;
      var _Constants$WebViewer = Constants.WebViewer,
        TOOLBAR_HEIGHT = _Constants$WebViewer.TOOLBAR_HEIGHT,
        KOMMENTAR_ARTICLE_BAR_HEIGHT = _Constants$WebViewer.KOMMENTAR_ARTICLE_BAR_HEIGHT,
        GAP = _Constants$WebViewer.GAP,
        KOMMENTAR_ARTICLE_BAR_LINE_HEIGHT = _Constants$WebViewer.KOMMENTAR_ARTICLE_BAR_LINE_HEIGHT,
        KOMMENTAR_ARTICLE_BAR_PADDING = _Constants$WebViewer.KOMMENTAR_ARTICLE_BAR_PADDING;
      var documentFindbarTop = function () {
        var height = GAP + TOOLBAR_HEIGHT;
        // コンメンタールの条文が表示されていない場合は通常の位置
        if (_this7.kommentarArticle === null) {
          return height;
        }
        // コンメンタールが閉じているときはフォントサイズから計算する（開いているときは固定値）
        var kommentarArticleBarHeight = _this7.isKommentarArticleBarOpen ? KOMMENTAR_ARTICLE_BAR_HEIGHT : _this7.config.bodyFontSize * KOMMENTAR_ARTICLE_BAR_LINE_HEIGHT + KOMMENTAR_ARTICLE_BAR_PADDING * 2;
        return height + GAP + kommentarArticleBarHeight;
      }();
      return {
        kommentarArticleBar: {
          top: "".concat(GAP + TOOLBAR_HEIGHT, "px")
        },
        documentFindbar: {
          top: "".concat(documentFindbarTop, "px")
        }
      };
    }
  }, {
    key: "constants",
    get: function get() {
      return Constants.WebViewer;
    }

    //
    // LIFE CYCLE
    //
  }, {
    key: "created",
    value: function () {
      var _created = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              // LWB-937: wklrの閲覧画面のパフォーマンスメトリクス (Sentry) を設定する
              this.registerPerformanceMetrics();
              this.WebviewerSections = generateWebviewerSections(this.record.toc);
              this.query.keyword = this.storedQuery.keyword || '';
              window.addEventListener('keydown', this.keydownEventHandler);
              document.addEventListener('selectionchange', this.selectionChangeHandler);
              if (!this.record.isKommentar) {
                _context.n = 4;
                break;
              }
              _context.p = 1;
              _context.n = 2;
              return this.$repositories.kommentar.getKommentarArticles(this.record.id);
            case 2:
              this.kommentarArticles = _context.v;
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              console.error('コンメンタールの条文との対応表が取得できませんでした');
              console.error(_t);
            case 4:
              this.reloadAllBinders();
              this.loadBinderItemsForDocument();
            case 5:
              return _context.a(2);
          }
        }, _callee, this, [[1, 3]]);
      }));
      function created() {
        return _created.apply(this, arguments);
      }
      return created;
    }()
  }, {
    key: "mounted",
    value: function () {
      var _mounted = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var _this8 = this;
        var _useContentMouseEvent, setIsPreview, setRecord, click, mouseout, mouseover;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              this.widerObserver = new IntersectionObserver(function (entries) {
                return _this8.loadAhead(entries);
              }, {
                root: this.$refs['wrap-document-body'],
                rootMargin: '0px 0px 400% 0px'
              });
              this.observer = new IntersectionObserver(function (entries) {
                return _this8.updateInViewContents(entries);
              }, {
                root: this.$refs['wrap-document-body']
              });
              this.loadInitialContent();
              _useContentMouseEvent = useContentMouseEvent(this.$repositories, this.$router, this.$toast, this.setSidenotePopup, this.setAvailabilityPopupTargetDocumentId, this.visitSection, function (x, y, items, query, fallback) {
                if (_this8.contextMenuModal.closeTimer) {
                  clearTimeout(_this8.contextMenuModal.closeTimer);
                }
                if (_this8.contextMenuModal.openTimer) {
                  clearTimeout(_this8.contextMenuModal.openTimer);
                }
                _this8.contextMenuModal.openTimer = setTimeout(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
                  var _t2;
                  return _regenerator().w(function (_context2) {
                    while (1) switch (_context2.p = _context2.n) {
                      case 0:
                        _context2.p = 0;
                        _this8.contextMenuModal.query = query;
                        _this8.contextMenuModal.positionX = x;
                        _this8.contextMenuModal.positionY = y;
                        _this8.contextMenuModal.isLoading = true;
                        _this8.contextMenuModal.visible = true;
                        _context2.n = 1;
                        return Promise.resolve(items());
                      case 1:
                        _this8.contextMenuModal.items = _context2.v;
                        _this8.contextMenuModal.isLoading = false;
                        _context2.n = 3;
                        break;
                      case 2:
                        _context2.p = 2;
                        _t2 = _context2.v;
                        fallback === null || fallback === void 0 ? void 0 : fallback(_t2);
                        _this8.contextMenuModal.visible = false;
                      case 3:
                        return _context2.a(2);
                    }
                  }, _callee2, null, [[0, 2]]);
                })), _this8.contextMenuModal.OPEN_INTERVAL);
              }, function (x, y, text) {
                _this8.tooltip.visible = true;
                _this8.tooltip.positionX = x;
                _this8.tooltip.positionY = y;
                _this8.tooltip.text = text;
              }, function () {
                if (_this8.contextMenuModal.closeTimer) {
                  clearTimeout(_this8.contextMenuModal.closeTimer);
                }
                if (_this8.contextMenuModal.openTimer) {
                  clearTimeout(_this8.contextMenuModal.openTimer);
                }
                _this8.contextMenuModal.closeTimer = setTimeout(function () {
                  _this8.contextMenuModal.visible = false;
                }, _this8.contextMenuModal.CLOSE_INTERVAL);
              }, function () {
                _this8.tooltip.visible = false;
              }, this.$domain.isSHKommentar || this.$domain.isSHKommentarLibrary), setIsPreview = _useContentMouseEvent.setIsPreview, setRecord = _useContentMouseEvent.setRecord, click = _useContentMouseEvent.click, mouseout = _useContentMouseEvent.mouseout, mouseover = _useContentMouseEvent.mouseover;
              this.isPreviewWatcher = setIsPreview;
              this.recordWatcher = setRecord;
              this.clickContent = click;
              this.mouseoutContent = mouseout;
              this.mouseoverContent = mouseover;
              setIsPreview(this.isPreview || false);
              setRecord(this.record);
            case 1:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function mounted() {
        return _mounted.apply(this, arguments);
      }
      return mounted;
    }()
  }, {
    key: "beforeDestroy",
    value: function beforeDestroy() {
      window.removeEventListener('keydown', this.keydownEventHandler);
      document.removeEventListener('selectionchange', this.selectionChangeHandler);
    }
  }, {
    key: "destroyed",
    value: function destroyed() {
      if (this.observer) {
        this.observer.disconnect();
      }
      if (this.widerObserver) {
        this.widerObserver.disconnect();
      }
      this.$repositories.sections.purge(this.record.id);
    }

    //
    // WATCH
    //
  }, {
    key: "notifyUpdatedInViewSections",
    value: function notifyUpdatedInViewSections() {
      // 現在画面内にいる最上部の series を key とセットで設定する
      // currentSection と currentSeries の整合性が取れなかった場合に undefined になって currentInViewInfo が更新されない
      // TODO: 実装的には currentSeries は currentSection に含まれるはずなので無視しているがなんらかの修正が必要になるかもしれない。 ref: LS-557
      var currentSection = this.inViewSections.length > 0 ? this.inViewSections[0] : undefined;
      var currentSeries = this.currentSeries;
      var section = this.WebviewerSections.find(function (section) {
        return section.state === 'loaded' && section.key === currentSection && section.contents.find(function (content) {
          return content.series === currentSeries;
        });
      });
      var currentInviewInfo = section !== undefined ? {
        key: section.key,
        series: currentSeries
      } : undefined;
      this.$emit('updateInViewSections', {
        inViewSections: this.inViewSections,
        inViewSectionsWithAncestors: this.inViewSectionsWithAncestors,
        currentInviewInfo: currentInviewInfo
      });
    }

    /** 本文内検索（次へ・前へ） */
  }, {
    key: "onCurrentHitUpdate",
    value: (function () {
      var _onCurrentHitUpdate = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var hit, _scrollFunc, _t3;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              // 前回の結果をクリアする
              document.querySelectorAll('.highlight.highlight-current').forEach(function (div) {
                return div.classList.remove('highlight-current');
              });
              if (!(this.find.hit.current === null || this.find.hit.documentHits === null)) {
                _context4.n = 1;
                break;
              }
              return _context4.a(2);
            case 1:
              hit = this.find.hit.documentHits.hits[this.find.hit.current];
              if (!(this.WebviewerSections[hit.parent] && this.WebviewerSections[hit.parent].state === 'beforeLoad')) {
                _context4.n = 6;
                break;
              }
              _context4.p = 2;
              _context4.n = 3;
              return this.load(hit.parent, !this.isFirstLoadDone);
            case 3:
              _context4.n = 5;
              break;
            case 4:
              _context4.p = 4;
              _t3 = _context4.v;
              console.error(_t3);
              this.$toast.open(this.loadFailureToastOptions);
            case 5:
              _context4.n = 6;
              return this.$nextTick();
            case 6:
              // 対象が表示されるまで待ってからスクロールする
              // 本来であれば vue.js のライフサイクルフックで対応したいが、タイミングなどの問題で難しいのでここで対応している
              _scrollFunc = function scrollFunc() {
                var target = document.querySelectorAll("[data-series=\"".concat(hit.series, "\"] .highlight"))[hit.offset];
                if (target instanceof HTMLElement) {
                  target.classList.add('highlight-current');
                  target.scrollIntoView({
                    block: 'center'
                  });
                } else {
                  setTimeout(_scrollFunc, 100);
                }
              };
              _scrollFunc();
            case 7:
              return _context4.a(2);
          }
        }, _callee4, this, [[2, 4]]);
      }));
      function onCurrentHitUpdate() {
        return _onCurrentHitUpdate.apply(this, arguments);
      }
      return onCurrentHitUpdate;
    }() //
    // METHODS
    //
    )
  }, {
    key: "shouldNotShowHighlightTooltip",
    get: function get() {
      return !this.$auth.permissions.binder || this.$domain.isMHMMypage || this.$domain.isSHKommentar || this.$domain.isSHKommentarLibrary;
    }
  }, {
    key: "getLabel",
    value: function getLabel(selection, record) {
      if (!selection) return undefined;
      var tocByKey = getTocByKey(selection.key, record.toc);
      return tocByKey && tocByKey.label;
    }

    /** 最初のコンテンツの読み込みを行う */
  }, {
    key: "loadInitialContent",
    value: (function () {
      var _loadInitialContent = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var hasInitialPosition, initialKey, _hit, series, _t4;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              if (!(this.isDocumentPage && location.pathname.split('/')[2] !== this.record.id)) {
                _context5.n = 1;
                break;
              }
              return _context5.a(2);
            case 1:
              hasInitialPosition = this.initialKey !== null || this.initialKeyByPage !== null;
              _context5.p = 2;
              if (!hasInitialPosition) {
                _context5.n = 5;
                break;
              }
              // 最初に表示する位置が指定されている場合はそこを優先して表示する
              initialKey = this.initialKey !== null ? this.initialKey : this.initialKeyByPage || 0;
              _context5.n = 3;
              return this.load(initialKey, true);
            case 3:
              _context5.n = 4;
              return this.visitSection(initialKey, this.initialSeries, {
                flash: this.emphasized
              });
            case 4:
              _context5.n = 9;
              break;
            case 5:
              if (!this.query.keyword) {
                _context5.n = 6;
                break;
              }
              _context5.n = 6;
              return this.waitForDocumentHitReady();
            case 6:
              _hit = this.find.hit.documentHits && this.find.hit.documentHits.hits[0] || undefined;
              if (!(_hit === undefined)) {
                _context5.n = 8;
                break;
              }
              _context5.n = 7;
              return this.load(0, true);
            case 7:
              _context5.n = 9;
              break;
            case 8:
              // 取得できる場合は、ヒットのうち最初のものにフォーカスする
              series = _hit.series;
              this.$store.commit('setCurrentHit', {
                current: 0,
                currentSeries: series
              });
              _context5.n = 9;
              return this.$nextTick();
            case 9:
              // SERP 等からの遷移の場合、文書内検索ボックスを最初から表示する
              if (this.query.keyword) {
                this.isShowSearchBox = true;
              }
              this.isFirstLoadDone = true;
              this.updateObserver();
              _context5.n = 11;
              break;
            case 10:
              _context5.p = 10;
              _t4 = _context5.v;
              console.error(_t4);
              this.$toast.open(this.loadFailureToastOptions);
            case 11:
              return _context5.a(2);
          }
        }, _callee5, this, [[2, 10]]);
      }));
      function loadInitialContent() {
        return _loadInitialContent.apply(this, arguments);
      }
      return loadInitialContent;
    }() /** documentHits のリクエストが完了する or 一定時間が経過するまで待つ */)
  }, {
    key: "waitForDocumentHitReady",
    value: function waitForDocumentHitReady() {
      var _this9 = this;
      return new Promise(function (resolve) {
        /** 検索キーワードがある時に取得完了まで待つ際のリトライ回数 */
        var firstLoadRetryCountForDocumentHit = 5; // 200ms * 5 = 1sec
        var _callback = function callback() {
          var hitsLength = _this9.find.hit.documentHits && _this9.find.hit.documentHits.hits && _this9.find.hit.documentHits.hits.length || 0;
          if (hitsLength < 1 && firstLoadRetryCountForDocumentHit > 0) {
            firstLoadRetryCountForDocumentHit--;
            setTimeout(_callback, 200);
            return;
          }
          resolve();
        };
        setTimeout(_callback, 200);
      });
    }

    /**
     * 動的ロードする
     * @param key ロード位置 (key)
     */
  }, {
    key: "load",
    value: (function () {
      var _load = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(key) {
        var _this0 = this;
        var withMargin,
          waitForLoad,
          response,
          _args6 = arguments,
          _t5;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.p = _context6.n) {
            case 0:
              withMargin = _args6.length > 1 && _args6[1] !== undefined ? _args6[1] : false;
              if (!(this.WebviewerSections[key].state === 'loaded')) {
                _context6.n = 1;
                break;
              }
              console.log("already loaded: ".concat(key));
              _context6.n = 7;
              break;
            case 1:
              if (!(this.WebviewerSections[key].state === 'loading')) {
                _context6.n = 3;
                break;
              }
              console.log("loading, waiting: ".concat(key));
              // ロードが終わるのを待つ
              waitForLoad = function waitForLoad() {
                return new Promise(function (resolve, reject) {
                  var cnt = 0;
                  var timer = setInterval(function () {
                    if (_this0.WebviewerSections[key].state === 'loaded') {
                      resolve();
                      clearInterval(timer);
                    }
                    if (cnt > 30) reject(new Error('コンテンツのロード待機がタイムアウトしました'));
                    ++cnt;
                  }, 100);
                });
              };
              _context6.n = 2;
              return waitForLoad();
            case 2:
              _context6.n = 7;
              break;
            case 3:
              if (!(this.WebviewerSections[key].state === 'beforeLoad')) {
                _context6.n = 7;
                break;
              }
              console.log("beforeLoad: ".concat(key));
              this.WebviewerSections[key].state = 'loading';
              _context6.p = 4;
              _context6.n = 5;
              return this.$repositories.sections.getSection(this.record.id, key, withMargin);
            case 5:
              response = _context6.v;
              response.forEach(function (section, i) {
                var depth = _this0.record.toc !== null ? depthByKey(section.key, _this0.record.toc.byKey) : 0; // 基本的に Toc が存在するはずだが存在しない場合はすべてフラットに depth 0 で計算する
                _this0.WebviewerSections[section.key].contents = convertSectionResponseToContents(section, depth);
                _this0.WebviewerSections[section.key].state = 'loaded';
              });
              _context6.n = 7;
              break;
            case 6:
              _context6.p = 6;
              _t5 = _context6.v;
              console.error(_t5);
              this.handleDocumentErrorToast();
              // TODO: content component にエラーを渡してリロードボタンなどを表示したい
            case 7:
              return _context6.a(2);
          }
        }, _callee6, this, [[4, 6]]);
      }));
      function load(_x) {
        return _load.apply(this, arguments);
      }
      return load;
    }() /** 文献内検索キーワードを更新する */)
  }, {
    key: "updateKeyword",
    value: function updateKeyword(keyword) {
      this.query.keyword = keyword;
    }

    /** 文書内検索 戻る・進むをクリックしたとき */
  }, {
    key: "jumpHit",
    value: function jumpHit(diff) {
      var _this1 = this;
      if (!this.find.hit.documentHits) {
        return;
      }

      // 初回は先頭
      var nextHit = function () {
        if (_this1.find.hit.current === null) return 0;
        var max = _this1.find.hit.documentHits.total;
        return (_this1.find.hit.current + max + diff) % max;
      }();
      var hit = this.find.hit.documentHits.hits[nextHit];
      if (hit === undefined) return;
      var series = hit.series;
      this.$store.commit('setCurrentHit', {
        current: nextHit,
        currentSeries: series
      });
    }
  }, {
    key: "openSettingDialog",
    value: function openSettingDialog() {
      this.$refs['document-config-dialog'].dialog = true;
    }
  }, {
    key: "setSidenotePopup",
    value: function setSidenotePopup(value) {
      this.sidenotePopup = value;
    }
  }, {
    key: "setAvailabilityPopupTargetDocumentId",
    value: function setAvailabilityPopupTargetDocumentId(value) {
      this.availabilityPopupTargetDocumentId = value;
    }
  }, {
    key: "checkIsInitialContent",
    value:
    //
    // ビュアー内の繊維系メソッド
    //

    /**
     * 対象の series が初期表示対象か（ URL で位置指定されいるか）をチェックする
     * @param series
     */
    function checkIsInitialContent(index) {
      // key が指定されていればそちら優先。ない場合はページから計算する
      var initialKey = this.initialKey || this.initialKeyByPage;
      var key = index.type === 'content' ? index.parent : index.key;
      var series = index.type === 'content' ? index.series : undefined;
      if (this.initialSeries !== null) {
        return this.initialSeries === series;
      }
      var ansecterKeys = [key].concat(_toConsumableArray(getAncesterSection(key, this.WebviewerSections)));
      if (initialKey === null) return false;
      return ansecterKeys.indexOf(initialKey) !== -1;
    }
  }, {
    key: "checkIsFlashContent",
    value: function checkIsFlashContent(content) {
      var series = content.type === 'content' ? content.series : undefined;
      var key = content.type === 'content' ? content.parent : content.key;
      if (this.flashSeries !== null) {
        return this.flashSeries === series;
      } else if (this.flashSection !== null) {
        var ansecterKeys = [key].concat(_toConsumableArray(getAncesterSection(key, this.WebviewerSections)));
        return ansecterKeys.indexOf(this.flashSection) !== -1;
      } else {
        return false;
      }
    }

    /**
     * 特定のセクションを表示
     * @param key
     */
  }, {
    key: "visitSection",
    value: (function () {
      var _visitSection = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(key, series) {
        var _this10 = this;
        var _ref2,
          flash,
          pushHistory,
          targetSeries,
          targetContentRef,
          visitTarget,
          targetElement,
          offset,
          url,
          _args7 = arguments,
          _t6;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.p = _context7.n) {
            case 0:
              _ref2 = _args7.length > 2 && _args7[2] !== undefined ? _args7[2] : {
                flash: false,
                pushHistory: false
              }, flash = _ref2.flash, pushHistory = _ref2.pushHistory;
              console.log("Visit Section by key: ".concat(key, " / series: ").concat(series));
              _context7.p = 1;
              _context7.n = 2;
              return this.load(key, true);
            case 2:
              _context7.n = 4;
              break;
            case 3:
              _context7.p = 3;
              _t6 = _context7.v;
              console.error(_t6);
              this.$toast.open(this.loadFailureToastOptions);
              return _context7.a(2);
            case 4:
              _context7.n = 5;
              return this.$nextTick();
            case 5:
              targetSeries = series || this.WebviewerSections[key].contents[0].series;
              targetContentRef = this.$refs["content-".concat(targetSeries)];
              visitTarget = Array.isArray(targetContentRef) ? targetContentRef[0] : targetContentRef;
              if (!(visitTarget == undefined || visitTarget instanceof Element)) {
                _context7.n = 6;
                break;
              }
              return _context7.a(2);
            case 6:
              targetElement = visitTarget.$el;
              if (targetElement instanceof HTMLElement) {
                // ターゲットの要素までスクロールする
                offset = targetElement.offsetTop;
                if (pushHistory) {
                  url = location.href;
                  history.pushState({}, document.title, url);
                }
                this.$nextTick(function () {
                  _this10.$refs['wrap-document-body'].scrollTo(0, offset);

                  // ターゲットのセクション（コンテント）を一瞬強調表示する
                  if (flash) {
                    if (series !== null) {
                      _this10.flashSeries = series;
                      _this10.flashSection = null;
                    } else {
                      _this10.flashSeries = null;
                      _this10.flashSection = key;
                    }
                    setTimeout(function () {
                      _this10.flashSeries = null;
                      _this10.flashSection = null;
                    }, 500);
                  }
                });
              }
            case 7:
              return _context7.a(2);
          }
        }, _callee7, this, [[1, 3]]);
      }));
      function visitSection(_x2, _x3) {
        return _visitSection.apply(this, arguments);
      }
      return visitSection;
    }() /** ページへ移動 */)
  }, {
    key: "gotoPage",
    value: function () {
      var _gotoPage = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(arg1) {
        var _this11 = this;
        var pageNumber, targetSection, targetContent, _t7;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.p = _context8.n) {
            case 0:
              if (!(this.record.toc === null)) {
                _context8.n = 1;
                break;
              }
              return _context8.a(2);
            case 1:
              pageNumber = typeof arg1 === 'number' ? arg1 : Math.max(0, (this.currentPageSeq || 0) + arg1.diff); // TODO: 現在のページと次のページの概念をきちんと決めて実装する
              targetSection = function () {
                var key = 0;
                // 今アクティブなページが存在しうる範囲より上をスキップする
                for (; key < _this11.record.toc.byKey.length; ++key) {
                  if (_this11.record.toc.byKey[key].pageSeq > pageNumber) {
                    return Math.max(key, 0);
                  } else if (_this11.record.toc.byKey[key].pageSeq === pageNumber) {
                    return key;
                  }
                }
                return key;
              }(); // 飛び先がまだロードされていないのでロードする
              if (!(this.WebviewerSections[targetSection] && this.WebviewerSections[targetSection].state === 'beforeLoad')) {
                _context8.n = 6;
                break;
              }
              _context8.p = 2;
              _context8.n = 3;
              return this.load(targetSection);
            case 3:
              _context8.n = 5;
              break;
            case 4:
              _context8.p = 4;
              _t7 = _context8.v;
              console.error(_t7);
              this.$toast.open(this.loadFailureToastOptions);
            case 5:
              _context8.n = 6;
              return this.$nextTick();
            case 6:
              targetContent = document.querySelector("[data-page-seq=\"".concat(pageNumber, "\"]"));
              if (!(targetContent instanceof HTMLElement)) {
                _context8.n = 8;
                break;
              }
              console.log('targetContent', targetContent.offsetTop);
              this.$refs['wrap-document-body'].scrollTo({
                top: targetContent.offsetTop
              });
              _context8.n = 7;
              return this.$nextTick();
            case 7:
              _context8.n = 9;
              break;
            case 8:
              _context8.n = 9;
              return this.visitSection(targetSection, null);
            case 9:
              this.hidePageBorder();
            case 10:
              return _context8.a(2);
          }
        }, _callee8, this, [[2, 4]]);
      }));
      function gotoPage(_x4) {
        return _gotoPage.apply(this, arguments);
      }
      return gotoPage;
    }() /** ページ番号ボックスでEnterキーを押して直接ジャンプ */
  }, {
    key: "gotoPageDirect",
    value: function gotoPageDirect(event) {
      if (!isAccessible(this.record)) {
        return;
      }
      var input = event.target.value;
      if (this.record.folioPerSeq) {
        // folioPerSeqがあれば入力がページ番号と完全一致したページに飛ぶ
        var index = this.record.folioPerSeq.indexOf(input);
        if (index > -1) {
          this.gotoPage(index);
        }
      } else {
        // 無ければPDFのページ番号とみなして飛ぶ
        this.gotoPage(Number.parseInt(input) - 1);
      }
    }

    /** このドキュメントを新しいタブで開く */
  }, {
    key: "openInNew",
    value: function openInNew() {
      // TODO: 本当はscrollTopとかで開きたい
      window.open(this.inViewContentUrl);
    }

    /** 特定のページに対応する部分を目立たせる */
  }, {
    key: "showPageBorder",
    value: function showPageBorder() {
      // TODO: ページ送りの修正を行うまで機能を消す
      return;

      /*
      let first!: HTMLElement;
      let last!: HTMLElement;
       console.log('page border: ', this.currentPageSeq);
      let styleTag = document.querySelector('style#style-page-border');
       if (styleTag == null) {
        styleTag = document.createElement('style');
        styleTag.id = 'style-page-border';
        document.head.appendChild(styleTag);
      }
       styleTag.textContent = `
        span[data-seq] {
          opacity: 0.3;
        }
         span[data-seq="${this.currentPageSeq}"] {
          opacity: inherit;
        }
      `;
       document.querySelectorAll<HTMLSpanElement>('span[data-seq]').forEach(span => {
        if (span.dataset.seq == this.currentPageSeq) {
          first = first ? first : span;
          last = span;
        }
      });
       if (this.currentPageSeq !== void 0) {
        this.pageBorderMarker.above =
          first == null || this.currentPageSeq === 0
            ? null
            : {
                text:
                  (this.record.folioPerSeq ? this.record.folioPerSeq[this.currentPageSeq - 1] : this.currentPageSeq) +
                  'ページ',
                position: first.offsetTop,
              };
         this.pageBorderMarker.below =
          last == null
            ? null
            : {
                text:
                  (this.record.folioPerSeq && this.currentPageSeq + 1 < this.record.folioPerSeq.length
                    ? this.record.folioPerSeq[this.currentPageSeq + 1]
                    : this.currentPageSeq + 2) + 'ページ',
                position: last.offsetTop + last.offsetHeight,
              };
      }
      */
    }

    /** 特定のページに対応する部分を目立たせるを解除 */
  }, {
    key: "hidePageBorder",
    value: function hidePageBorder() {
      // TODO: ページ送りの修正を行うまで機能を消す
      return;

      /*
      const styleTag = document.querySelector<HTMLStyleElement>('style#style-page-border');
       if (styleTag && styleTag.sheet) {
        styleTag.sheet.disabled = true;
        styleTag.remove();
      }
       this.pageBorderMarker = { above: null, below: null };
      */
    }

    /** 検索ボックスの表示・非表示を切り替える */
  }, {
    key: "toggleSearchBox",
    value: function toggleSearchBox(e) {
      if (this.isShowSearchBox === false) {
        this.focusSearchBox(e);
      } else {
        this.hideSearchBox(e);
      }
    }

    /** ctrl+fで検索ボックスを表示・フォーカス */
  }, {
    key: "focusSearchBox",
    value: function focusSearchBox(e) {
      this.isShowSearchBox = true;
      this.$refs['document-findbar'].focus();
      e.preventDefault();
      e.stopImmediatePropagation();
    }

    /** escで検索ボックスを非表示 */
  }, {
    key: "hideSearchBox",
    value: function hideSearchBox(e) {
      if (e.isComposing) return;
      this.isShowSearchBox = false;

      // 現在のハイライトを削除
      this.$emit('clearFind');
      this.query.keyword = '';
      e.preventDefault();
      e.stopImmediatePropagation();
    }
  }, {
    key: "keydownEventHandler",
    value: function keydownEventHandler(e) {
      if (e.key === 'f' && (e.ctrlKey || e.metaKey)) {
        this.focusSearchBox(e);
      } else if (e.key === 'Escape') {
        this.hideSearchBox(e);
      }
    }
  }, {
    key: "watchHighlightDialog",
    value: function watchHighlightDialog(flag) {
      if (!flag) {
        this.deselectSelection();
        this.selection = null;
        this.selectedBinderToHighlight = null;
        this.editingHighlightDescription = '';
      }
    }
  }, {
    key: "ellipsisSelectionText",
    get: function get() {
      var MAX_LENGTH = 200;
      if (this.selection === null) return '';
      if (this.selection.highlightedText.length <= MAX_LENGTH) return this.selection.highlightedText;
      // TODO: サロゲートペアを考慮した実装にする（参考: https://jsfiddle.net/1urnmdL8/ ）
      return "".concat(this.selection.highlightedText.substring(0, MAX_LENGTH / 2), "...").concat(this.selection.highlightedText.substring(this.selection.highlightedText.length - MAX_LENGTH / 2));
    }
  }, {
    key: "highlightButtonClickHandler",
    value: function highlightButtonClickHandler() {
      if (this.selection !== null) {
        this.reloadAllBinders();
        this.highlightDialog = true;
        this.selectedBinderToHighlight = null;
        this.editingHighlightDescription = '';
        this.deselectSelection();
      } else {
        this.highlightDialog = false;
      }
    }
  }, {
    key: "correctionReportHandler",
    value: function correctionReportHandler() {
      var _this12 = this;
      if (this.selection == null) return;
      var match = document.cookie.match(/(?:^|\s| ;)userId=(\S+)/);
      var userId = btoa(match ? match[1] : '');
      var url = Constants.CorrectionReport.GoogleFormsURLPattern.replace('{TITLE}', encodeURIComponent(this.record.title)).replace('{ID}', encodeURIComponent(this.record.id)).replace('{SECTION}', encodeURIComponent(this.selection.key)).replace('{SELECTION}', encodeURIComponent(this.selection.highlightedText)).replace('{USER_ID}', userId);
      window.addEventListener('focus', function () {
        return _this12.$toast.success('ご協力ありがとうございます😄');
      }, {
        once: true
      });
      window.open(url);
    }
  }, {
    key: "copySelectionHandler",
    value: function () {
      var _copySelectionHandler = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9() {
        var url, _t8;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.p = _context9.n) {
            case 0:
              _context9.p = 0;
              if (!(this.selection === null)) {
                _context9.n = 1;
                break;
              }
              throw new Error('選択範囲が存在しません');
            case 1:
              url = fragmentUrl(this.record, this.selection.key.toString());
              _context9.n = 2;
              return navigator.clipboard.writeText("".concat(this.selection.highlightedText, "\n\n").concat(fragmentBibliography(this.record), " ").concat(url));
            case 2:
              this.$toast.success("\u9078\u629E\u7BC4\u56F2\u3092\u30B3\u30D4\u30FC\u3057\u307E\u3057\u305F");
              _context9.n = 4;
              break;
            case 3:
              _context9.p = 3;
              _t8 = _context9.v;
              this.$toast.error('コピーできませんでした');
            case 4:
              return _context9.a(2);
          }
        }, _callee9, this, [[0, 3]]);
      }));
      function copySelectionHandler() {
        return _copySelectionHandler.apply(this, arguments);
      }
      return copySelectionHandler;
    }()
  }, {
    key: "selectionCommitHandler",
    value: function () {
      var _selectionCommitHandler = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0() {
        var _this13 = this;
        var binder, response, color, hls, _t9;
        return _regenerator().w(function (_context0) {
          while (1) switch (_context0.p = _context0.n) {
            case 0:
              if (!(this.selection === null || this.selectedBinderToHighlight === null)) {
                _context0.n = 1;
                break;
              }
              this.highlightDialog = false;
              return _context0.a(2);
            case 1:
              binder = this.findBinderBy(this.selectedBinderToHighlight);
              if (binder) {
                _context0.n = 2;
                break;
              }
              this.highlightDialog = false;
              return _context0.a(2);
            case 2:
              _context0.p = 2;
              _context0.n = 3;
              return this.$repositories.binderFolders.addHighlightToBinder(binder.id, this.record.id, this.editingHighlightDescription,
              // TODO: /api/v2/documents/{id} のレスポンスに docDataUpdatedAt が実装されたらそれを使うように置き換える
              this.record.publishedOn === null ? null : new Date(this.record.publishedOn).getTime() / 1000, this.selection.key, this.selection.sectionTitle, this.selection.precedingText, this.selection.highlightedText, this.selection.followingText, this.selection.highlightedContents);
            case 3:
              response = _context0.v;
              color = binder.highlightColor;
              hls = extractHighlightContentsWithColor(color, [response]);
              hls.forEach(function (hl) {
                if (Array.isArray(_this13.innerHighlights[hl.series])) {
                  _this13.innerHighlights[hl.series].push(hl);
                } else {
                  Vue.set(_this13.innerHighlights, hl.series, [hl]);
                }
              });
              this.highlightDialog = false;
              this.$emit('change-document-binder-items');
              this.$toast.success('バインダーに登録しました');
              _context0.n = 5;
              break;
            case 4:
              _context0.p = 4;
              _t9 = _context0.v;
              this.$refs['highlight-dialog'].reactivate();
              console.error(_t9);
              this.$toast.error('バインダーへの登録に失敗しました');
            case 5:
              return _context0.a(2);
          }
        }, _callee0, this, [[2, 4]]);
      }));
      function selectionCommitHandler() {
        return _selectionCommitHandler.apply(this, arguments);
      }
      return selectionCommitHandler;
    }()
  }, {
    key: "deselectSelection",
    value: function deselectSelection() {
      var selection = document.getSelection();
      if (!selection || selection.isCollapsed || selection.rangeCount !== 1) {
        return;
      }
      if (selection.removeAllRanges) {
        selection.removeAllRanges();
      } else if (selection.empty) {
        selection.empty();
      }
    }

    /** document に attach してテキスト選択範囲が変更になった時に処理を行う */
  }, {
    key: "selectionChangeHandler",
    value: function selectionChangeHandler(e) {
      var selection = document.getSelection();

      // webビューが1画面に複数個配置されている場合、他webビューの範囲選択のeventも来てしまうので、自分のものかをチェック
      var isMine = false;
      var current = selection ? selection.anchorNode : undefined;
      while (current) {
        if (current === this.$el) {
          isMine = true;
          break;
        }
        current = current.parentNode;
      }

      // ダイアログ表示中は何もしない
      if (this.highlightDialog) {
        return;
      }
      if (!selection || selection.isCollapsed || selection.rangeCount !== 1 || !isMine) {
        this.selection = null;
      } else {
        this.invokeInfoCopy(selection);
      }
    }

    /** ブックマークの配列を content から求める */
  }, {
    key: "getHighlightsBySeries",
    value: function getHighlightsBySeries(index) {
      if (index.type === 'section') return [];
      return this.innerHighlights[index.series] || [];
    }

    /** テキスト選択時 (mouseup) をフックして、書誌情報を選択範囲に差し込む */
    // FIXME: 早期リターンする時に処理を挟み込みたいので try { ... } catch() { .. } 構文にしたい
  }, {
    key: "invokeInfoCopy",
    value: function invokeInfoCopy(selection) {
      console.log('invokeInfoCopy: STEP1', selection);

      // v-dialog のタイミングで前の selection が消えていないことがあるのでここで無理やり消す
      this.selection = null;
      this.selectedBinderToHighlight = null;
      this.editingHighlightDescription = '';
      var anchorNode = selection.anchorNode,
        focusNode = selection.focusNode,
        anchorOffset = selection.anchorOffset,
        focusOffset = selection.focusOffset;
      if (!anchorNode || !focusNode) {
        return;
      }
      console.log('invokeInfoCopy: STEP2');
      var startNode;
      var endNode;
      var startOffset;
      var endOffset;
      if (anchorNode === focusNode) {
        // 同じノードの場合オフセットだけ入れ替える
        startNode = endNode = anchorNode;
        var _ref3 = anchorOffset > focusOffset ? [focusOffset, anchorOffset] : [anchorOffset, focusOffset];
        var _ref4 = _slicedToArray(_ref3, 2);
        startOffset = _ref4[0];
        endOffset = _ref4[1];
      } else if (compareNode(anchorNode, focusNode)) {
        // 違うノードの場合並び順でノードとオフセットを入れ替える
        startNode = anchorNode;
        endNode = focusNode;
        startOffset = anchorOffset;
        endOffset = focusOffset;
      } else {
        // 違うノードの場合並び順でノードとオフセットを入れ替える
        startNode = focusNode;
        endNode = anchorNode;
        startOffset = focusOffset;
        endOffset = anchorOffset;
      }
      var startParagraphNode = getWrapperNode(startNode);
      if (startParagraphNode == null) return;
      var startKey = startParagraphNode.dataset.parentKey;
      var endParagraphNode = getWrapperNode(endNode);
      if (endParagraphNode == null) return;
      var endKey = endParagraphNode.dataset.parentKey;

      // セクションをまたいでのハイライトはできないようにする
      if (startKey !== endKey) {
        this.selection = null;
        return;
      }
      var _ref5 = startParagraphNode === endParagraphNode ? getHighlightFromSingleNode(startParagraphNode, startOffset, endOffset, startNode, endNode) : getHighlightsFromMultiNode(startParagraphNode, startOffset, endParagraphNode, endOffset, startNode, endNode, getMiddleNodesFromSelectionByKey(selection, startKey)),
        highlightedContents = _ref5.highlightedContents,
        text = _ref5.text;
      if (highlightedContents.length < 1) return;
      var startPosition = highlightedContents[0].startPosition;
      var endPosition = highlightedContents.reduce(function (acc, cur) {
        return acc + cur.endPosition;
      }, 0);
      var key = Number(startKey);
      var toc = getTocByKey(key, this.record.toc);
      var sectionTitle = toc ? toc.label : '';
      // TODO: key が NaN だった場合と、 sectionTitle が取得できなかった時の処理を実装する

      this.selection = {
        key: key,
        sectionTitle: sectionTitle,
        precedingText: text.substring(0, startPosition),
        highlightedText: text.substring(startPosition, endPosition),
        followingText: text.substring(endPosition),
        highlightedContents: highlightedContents
      };
      var wrapperElement = this.$refs['wrap-document-body'];
      var _selection$getRangeAt = selection.getRangeAt(0).getBoundingClientRect(),
        rectTop = _selection$getRangeAt.top,
        rectLeft = _selection$getRangeAt.left,
        rectWidth = _selection$getRangeAt.width;
      var relativeLeft = rectLeft - wrapperElement.getBoundingClientRect().left; // 選択範囲の絶対位置左をラッパーからの相対位置に直したもの
      var relativeTop = rectTop - wrapperElement.getBoundingClientRect().top; // 選択範囲の絶対位置上をラッパーからの相対位置に直したもの

      // 選択範囲の上端
      var top = relativeTop + wrapperElement.scrollTop - wrapperElement.offsetTop;

      // 選択範囲がテキストノードではなくなった場合、 body-content-action-area 分左に左にずれるので調整する
      var boxContentLeftPadding = highlightedContents.length > 1 ? 28 : 0;

      // 選択範囲の左位置
      var left = relativeLeft + boxContentLeftPadding;

      // 選択範囲の右位置（現在は使っていないが toolbox を右寄せにする際に利用する）
      var right = relativeLeft + rectWidth;

      // ラッパーの右端（現在は使っていないが toolbox を右寄せにする際に利用する）
      var wrapperRight = wrapperElement.offsetWidth - 42;
      this.selectionPosition = {
        top: top,
        right: right,
        left: left,
        wrapperRight: wrapperRight
      };
    }
  }, {
    key: "clickQuickAccessItemHandler",
    value: function clickQuickAccessItemHandler(tocId) {
      this.$refs.addQuickAccessItemDialog.show(tocId);
    }
  }, {
    key: "clickBinderHandler",
    value: function clickBinderHandler(tocId) {
      this.$refs.addBookmarkDialog.show(tocId);
    }

    // binder 権限がある場合、このメソッドはブックマークとクイックアクセス両方の登録で呼ばれることに注意
  }, {
    key: "updateAddedBookmark",
    value: function updateAddedBookmark(response, binder) {
      if ('binderId' in response) {
        this.addBookmark(response, binder);
      } else {
        this.addQuickAccessItem(response);
      }
      this.$forceUpdate();
    }
  }, {
    key: "updateAddedQuickAccessItem",
    value: function updateAddedQuickAccessItem(response) {
      if (response.viewType !== QuickAccessItemTypeWebPropertiesViewTypeEnum.Web) {
        // ここには到達しないはずではあるが、web ビューにおいて PDF のクイックアクセスアイテムに対してやることはない
        return;
      }
      this.addQuickAccessItem(response);
      this.$forceUpdate();
    }

    /** ブックマークの配列を content から求める */
  }, {
    key: "getBookmarksBy",
    value: function getBookmarksBy(index) {
      if (index.type !== 'content') return [];
      return this.bookmarksWithBinderDetail[index.parent] || [];
    }
  }, {
    key: "getQuickAccessItemsBy",
    value: function getQuickAccessItemsBy(index) {
      if (index.type !== 'content') return [];
      return this.quickAccessItems[index.parent] || [];
    }

    // ハイライトとブックマークの登録ダイアローグ共通
  }, {
    key: "findBinderBy",
    value: function findBinderBy(id) {
      return this.binders.find(function (b) {
        return b.id === id;
      });
    }

    /**
     * 最新のバインダー一覧を取得し直します。バインダー権限がない場合は何もしません。
     */
  }, {
    key: "reloadAllBinders",
    value: (function () {
      var _reloadAllBinders = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1() {
        var _t0;
        return _regenerator().w(function (_context1) {
          while (1) switch (_context1.p = _context1.n) {
            case 0:
              if (!this.$auth.permissions.binder) {
                _context1.n = 4;
                break;
              }
              _context1.p = 1;
              _context1.n = 2;
              return this.$repositories.binderFolders.getAllBinders();
            case 2:
              this.binders = _context1.v;
              _context1.n = 4;
              break;
            case 3:
              _context1.p = 3;
              _t0 = _context1.v;
              console.error('バインダー一覧を取得できませんでした');
              console.error(_t0);
            case 4:
              return _context1.a(2);
          }
        }, _callee1, this, [[1, 3]]);
      }));
      function reloadAllBinders() {
        return _reloadAllBinders.apply(this, arguments);
      }
      return reloadAllBinders;
    }()
    /**
     * 表示しているドキュメントが含まれているブックマークとハイライトを取得する
     */
    )
  }, {
    key: "loadBinderItemsForDocument",
    value: (function () {
      var _loadBinderItemsForDocument = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10() {
        var result, binderItems;
        return _regenerator().w(function (_context10) {
          while (1) switch (_context10.n) {
            case 0:
              _context10.n = 1;
              return this.$repositories.docs.getMyCollectionItemsForDocument(this.record.id);
            case 1:
              result = _context10.v;
              if (result.quickAccessItemsResult.isFailure()) {
                this.$toast.error('クイックアクセスアイテムの取得に失敗しました。');
              } else {
                this.setQuickAccessItems(result.quickAccessItemsResult.value.partial);
              }
              if (this.$auth.permissions.binder) {
                if (result.binderItemsResult.isFailure()) {
                  this.$toast.error('バインダーアイテムの取得に失敗しました。');
                } else {
                  binderItems = result.binderItemsResult.value;
                  this.setBookmark(binderItems);
                  this.innerHighlights = mapBySeries(binderItems.flatMap(function (binderItem) {
                    return extractHighlightContentsWithColor(binderItem.binder.highlightColor, binderItem.highlights);
                  }));
                }
              }
              // binder パーミッションがない場合は結果にかかわらずバインダー系は更新しない
              // FIXME: パーミッションがなければそもそもバインダーAPIを叩かないようにする
            case 2:
              return _context10.a(2);
          }
        }, _callee10, this);
      }));
      function loadBinderItemsForDocument() {
        return _loadBinderItemsForDocument.apply(this, arguments);
      }
      return loadBinderItemsForDocument;
    }())
  }, {
    key: "selectedBinderColorClassName",
    get: function get() {
      if (this.selectedBinderToHighlight) {
        var binder = this.findBinderBy(this.selectedBinderToHighlight);
        if (binder) {
          return "-".concat(highlightColorName(binder.highlightColor));
        }
      }
      return '';
    }

    //
    // Intersection Observer
    //
  }, {
    key: "inViewHandler",
    value: function inViewHandler(key) {
      if (this.WebviewerSections[key] && this.WebviewerSections[key].state === 'beforeLoad') {
        try {
          this.load(key);
        } catch (error) {
          console.error(error);
          this.$toast.open(this.loadFailureToastOptions);
        }
      }
    }
  }, {
    key: "loadAhead",
    value: function loadAhead(entries) {
      var _this14 = this;
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          console.log('loadAhead', entry);
          var target = entry.target;
          if (target instanceof HTMLElement) {
            var loadingSection = target.dataset.loadingSection;
            if (loadingSection !== void 0) {
              var keyNumber = Number.parseInt(loadingSection, 10);
              _this14.inViewHandler(keyNumber); // this が参照するインスタンスが現在のものではないため、別関数を呼び出してスコープを切り替える
            }
          }
        }
      });
    }
  }, {
    key: "updateInViewContents",
    value: function updateInViewContents(entries) {
      // 新しく画面内に入った series
      var seriesOfInViewContentsToAdd = new Set();
      // 画面外に出た series
      var seriesOfInViewContentsToRemove = new Set();
      entries.forEach(function (entry) {
        var target = entry.target;
        if (target instanceof HTMLElement) {
          var seriesString = target.dataset.series;
          if (seriesString !== undefined) {
            var series = Number(seriesString);

            /*
            監視対象が高速に出たり入ったりする場合、entriesに同じ監視対象が入る場合がある。
            entriesはeventが発生した順に入っている（NOTE:本当か？）ようなので、seriesOfInViewContentsToXXXは最後の状態を保持するように更新する。
             */
            if (entry.isIntersecting) {
              seriesOfInViewContentsToAdd.add(series);
              seriesOfInViewContentsToRemove.delete(series);
            } else {
              seriesOfInViewContentsToAdd.delete(series);
              seriesOfInViewContentsToRemove.add(series);
            }
          }
        }
      });
      this.seriesOfInViewContents = mergeSortedArraysToUniqueArray(this.seriesOfInViewContents, Array.from(seriesOfInViewContentsToAdd.values()).sort(), seriesOfInViewContentsToRemove);
    }
  }, {
    key: "updateObserver",
    value: function updateObserver() {
      var _this15 = this;
      if (!this.isFirstLoadDone) return;
      this.$nextTick(function () {
        _this15.observeDynamicContents();
      });
    }

    /** observerをセットする */
    // TODO: 毎回すべての refs をチェックしている。本来であれば各コンポーネントが自律的に observer に登録される方が良さそう
  }, {
    key: "observeDynamicContents",
    value: function observeDynamicContents() {
      var _this16 = this;
      Object.keys(this.$refs).filter(function (ref) {
        return ref.substr(0, 8) === 'content-';
      }).flatMap(function (ref) {
        return _this16.$refs[ref];
      }).forEach(function (ref) {
        var el = ref instanceof Element ? ref : ref.$el;
        if (el instanceof HTMLElement) {
          if (!el.dataset.observed) {
            el.dataset.observed = 'true';
            _this16.widerObserver.observe(el);
            _this16.observer.observe(el);
          }
        }
      });
    }
  }, {
    key: "setBookmark",
    value: function setBookmark(response) {
      var bookmarks = response.flatMap(function (binderItem) {
        return binderItem.bookmarks.map(function (bookmark) {
          var docId = bookmark.docId,
            rest = _objectWithoutProperties(bookmark, _excluded);
          return rest;
        }).map(function (bookmark) {
          return _objectSpread(_objectSpread({}, bookmark), {}, {
            binder: binderItem.binder
          });
        }).filter(function (bookmark) {
          return bookmark.viewType === BookmarkViewTypeEnumWeb.Web;
        });
      });
      this.bookmarksWithBinderDetail = mapByKey(bookmarks);
    }
  }, {
    key: "setQuickAccessItems",
    value: function setQuickAccessItems(response) {
      var items = response.map(function (item) {
        var docId = item.docId,
          rest = _objectWithoutProperties(item, _excluded2);
        return rest;
      }).filter(function (item) {
        return item.viewType === BookmarkViewTypeEnumWeb.Web;
      });
      this.quickAccessItems = mapByKey(items);
    }
  }, {
    key: "addBookmark",
    value: function addBookmark(response, binder) {
      if (this.bookmarksWithBinderDetail[response.key]) {
        this.bookmarksWithBinderDetail[response.key].push(_objectSpread(_objectSpread({}, response), {}, {
          binder: binder
        }));
      } else {
        this.$set(this.bookmarksWithBinderDetail, response.key, [_objectSpread(_objectSpread({}, response), {}, {
          binder: binder
        })]);
      }
    }
  }, {
    key: "addQuickAccessItem",
    value: function addQuickAccessItem(response) {
      if (this.quickAccessItems[response.key]) {
        this.quickAccessItems[response.key].push(response);
      } else {
        this.$set(this.quickAccessItems, response.key, [response]);
      }
    }
  }, {
    key: "registerPerformanceMetrics",
    value: function registerPerformanceMetrics() {
      var observed = false;
      var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          if (observed) return;
          if (mutation.type === 'childList') {
            var target = document.querySelector('.body-content-text');
            if (target) {
              endNavigationOrPageloadSpan();
              observed = true;
              observer.disconnect();
            }
          }
        });
      });
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }
  }]);
}(Vue), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "record", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "initialPage", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "initialKey", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "initialSeries", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "emphasized", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "isPreview", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, "isDocumentPage", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, "find", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class2.prototype, "storedQuery", [_dec0], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor0 = _applyDecoratedDescriptor(_class2.prototype, "config", [_dec1], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor1 = _applyDecoratedDescriptor(_class2.prototype, "bookmark", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class2.prototype, "highlight", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class2.prototype, "notifyUpdatedInViewSections", [_dec12], Object.getOwnPropertyDescriptor(_class2.prototype, "notifyUpdatedInViewSections"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onCurrentHitUpdate", [_dec13], Object.getOwnPropertyDescriptor(_class2.prototype, "onCurrentHitUpdate"), _class2.prototype), _descriptor11 = _applyDecoratedDescriptor(_class2.prototype, "isPreviewWatcher", [_dec14], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return function () {};
  }
}), _descriptor12 = _applyDecoratedDescriptor(_class2.prototype, "recordWatcher", [_dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return function () {};
  }
}), _applyDecoratedDescriptor(_class2.prototype, "watchHighlightDialog", [_dec16], Object.getOwnPropertyDescriptor(_class2.prototype, "watchHighlightDialog"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "updateObserver", [_dec17], Object.getOwnPropertyDescriptor(_class2.prototype, "updateObserver"), _class2.prototype), _class2)) || _class);
export { WebViewer as default };